<template>
  <vuetify-aggregator-card
    ref="aggregator"
    :color="color"
    :toolbar-title="toolbarTitle"
    :list-title="listTitle"
    :persistent="true"
    :navigation-menu="navigationMenu"
    :add-button-hover-text="addButtonHoverText"
    :dialog-max-width="dialogMaxWidth"
    :dialog-toolbar-title="theDialogToolbarTitle"
  >
    <v-list style="max-height: 282px" class="scroll-y" three-line slot="card-text" v-if="items.length > 0">
      <transition-group name="list" tag="span">
        <template v-for="(item, index) in items">
          <v-list-tile ripple avatar :key="(index + 2 * 100)" @click="openFile(index)">
            <v-list-tile-action>
              <v-icon :color="color">attach_file</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.booking_document_title }}
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{ item.booking_document_user }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{ item.booking_document_filename }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="deleteButton">
              <v-tooltip bottom>
                <v-btn slot="activator" icon flat :color="color" @click="askForConfirmation(index)">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>{{ deleteIconHoverText }}</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 !== items.length" :inset="false" :key="(index + 1 * 100)"></v-divider>
        </template>
      </transition-group>
    </v-list>

    <v-layout slot="dialog-card-text" row align-center justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-form ref="form" v-model="valid">
          <v-flex xs12 sm12 md12 lg6>
            <v-text-field
              :label="textFieldLabel"
              single-line
              :disabled="disableTitle"
              required
              :rules="textFieldRules || []"
              v-model="documentTitle"
            ></v-text-field>
            <v-btn
              :loading="loading"
              :disabled="loading"
              @click="selectSignatureFile()"
              color="primary"
              class="white--text"
              @click.native="loader = 'loading'"
            >
              {{ filename || 'Subir' }}
              <v-icon right dark>cloud_upload</v-icon>
            </v-btn>
          </v-flex>
        </v-form>
      </v-flex>
    </v-layout>
    
    <div slot="dialog-card-actions">
      <input @change="checkFile()" ref="input" type="file" id="file" class="input-file">
      <v-btn
        :color="color"
        flat
        @click.native="closeDialog()"
      >
        {{ cancelButton }}
      </v-btn>
      <v-btn
        v-show="documentTitle && url"
        :color="color"
        flat
        @click.native="addDocument()"
      >
        {{ confirmButton }}
      </v-btn>
    </div>

    <vuetify-dialog-confirm
      slot="extras"
      :headline="dialogConfirmHeadline"
      :text="dialogConfirmText"
      :cancel="cancelButton"
      :confirm="confirmButton"
      @on-cancel-dialog="onDiscardDeletion"
      @on-confirm-dialog="onConfirmDeletion"
      v-model="showConfirmDialog"
    ></vuetify-dialog-confirm>

  </vuetify-aggregator-card>
</template>

<script>
  'use strict'

  import VuetifyAggregatorCard from '@/layouts/vuetify-aggregator-card'
  import VuetifyDialogConfirm from '@/components/vuetify-dialog-confirm'

  export default {

    name: 'VuetifyDocumentAggregator',

    components:
    {
      VuetifyAggregatorCard,
      VuetifyDialogConfirm
    },

    props: {
      documents: {
        type: Array,
        default: null,
        required: true
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      toolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      listTitle: {
        type: String,
        default: null,
        required: true
      },
      addButtonHoverText: {
        type: String,
        default: null,
        required: true
      },
      dialogMaxWidth: {
        type: Number,
        default: 450,
        required: false
      },
      dialogToolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      textFieldLabel: {
        type: String,
        default: 'Phone',
        required: false
      },
      textFieldRules: {
        type: Array,
        default: null,
        required: false
      },
      selectLabel: {
        type: String,
        default: 'Type',
        required: false
      },
      documentTypes: {
        type: Array,
        default: null,
        required: false
      },
      dialogConfirmHeadline: {
        type: String,
        default: 'Delete area',
        required: false
      },
      dialogConfirmText: {
        type: String,
        default: 'Estás a punto de eliminar un área de trabajo',
        required: false
      },
      cancelButton: {
        type: String,
        default: 'Cancel',
        required: false
      },
      confirmButton: {
        type: String,
        default: 'Confirm',
        required: false
      },
      deleteIconHoverText: {
        type: String,
        default: 'Delete',
        required: false
      },
      deleteButton: {
        type: Boolean,
        default: true,
        required: false
      },
      navigationMenu: {
        type: Boolean,
        default: true,
        required: false
      },
      value: {
        type: Array,
        default: null
      }
    },

    data: () => ({
      items: [],
      dialog: false,
      valid: false,
      title: '',
      url: '',
      filename: '',
      filetype: '',
      type: '',
      user: '',
      loader: null,
      loading: false,
      preview: false,
      disableTitle: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: [
        {
          text: 'Phone'
        },
        {
          text: 'Mobile'
        },
        {
          text: 'Fax'
        }
      ],
      theDocumentType: '1',
      file: null,
      documentType: null,
      documentTitle: null,
      documentMsg: null,
      theDialogToolbarTitle: ''
    }),

    created () {
      this.items = this.documents
      this.theDialogToolbarTitle = this.dialogToolbarTitle
    },

    watch: {
      documentTypes: {
        handler: function (newVal, oldVal) {
          this.types = newVal
          this.documentType = this.types[0]
        },
        deep: true
      },

      documents: {
        handler: function (newVal, oldVal) {
          this.items = newVal
        },
        deep: true
      },

      items: {
        handler: function (newVal, oldVal) {
          this.$emit('update:value', newVal)
        },
        deep: true
      }
    },

    methods: {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      askForConfirmation (index) {
        this.currentIndex = index
        this.showConfirmDialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      checkFile () {
        this.loading = true
        let file = this.$refs.input.files[0]
        this.filename = this.filename || file.name || ''
        this.filetype = file.type || ''
        let reader = new FileReader()
        reader.readAsDataURL(file)
        let self = this
        reader.addEventListener('load', function () {
          self.url = reader.result
          self.loading = false
        }, false)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      selectSignatureFile () {
        this.$refs.input.value = ''
        this.$refs.input.click()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDiscardDeletion (ref) {
        this.showConfirmDialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onConfirmDeletion () {
        this.showConfirmDialog = false
        this.deleteDocument()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteDocument () {
        this.$emit('on-delete-document', this.currentIndex, this.items[this.currentIndex])
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openFile (index) {
        console.error(this.items)
        if (!this.showConfirmDialog) {
          console.log('ddddddddd', this.items[index].booking_document_url)
          let win = window.open(this.items[index].booking_document_url.replace('public/documents/bookings', 'shared/documents/bookings') + '?isAuthorized', '_blank')
          win.focus()
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openDialog (dialogTitle, title, disableTitle, filename) {
        this.disableTitle = disableTitle
        this.theDialogToolbarTitle = dialogTitle
        this.documentTitle = title || this.documentTitle
        this.theDialogToolbarTitle = dialogTitle
        this.filename = filename || this.filename
        this.$refs.aggregator.dialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      closeDialog () {
        this.documentTitle = ''
        this.disableTitle = false
        this.theDialogToolbarTitle = this.dialogToolbarTitle
        this.$refs.aggregator.dialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addDocument () {
        let item = {
          booking_id: 0,
          booking_document_url: this.url,
          user_id: 0,
          booking_document_id: 0,
          booking_document_title: this.documentTitle,
          booking_document_filetype: this.filetype,
          booking_document_filename: this.filename
        }
        this.$refs.form.reset()
        this.url = ''
        this.filename = ''
        this.filetype = ''
        this.$emit('on-add-document', item)
        this.closeDialog()
      }
    }
  }
</script>

<style lang="sass">
.types
  margin: 0 auto
  text-align: center
  display: table
</style>


// WEBPACK FOOTER //
// src/components/vuetify-document-aggregator.vue